import StyledCloseBubbleButton from '../../styles/StyledCloseBubbleButton';

interface CloseBubbleButtonProps {
  onClick: () => void;
}

const CloseBubbleButton = ({ onClick }: CloseBubbleButtonProps) => {
  return (
    <StyledCloseBubbleButton onClick={onClick}>
      x
    </StyledCloseBubbleButton>
  );
};

export default CloseBubbleButton;